class Modal {
  constructor(DOMelement, openButtonsDOMlist) {
    try {
      this.isOpen = false;
      this.el = DOMelement;
      this.contentWrapper = DOMelement.querySelector(".sd-modal__content");
      this.carouselWrapper  = DOMelement.querySelectorAll(".sd-carousel");
      this.closeButton = DOMelement.querySelector(".sd-modal__close");
      this.openButtons = openButtonsDOMlist;
      [...openButtonsDOMlist].forEach((button) =>
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.open();
        })
      );
      this.el.addEventListener("click", (event) => {
        if(event.target == this.el){
          this.close();
        }
        this.carouselWrapper.forEach((element) => {
          if(event.target == element){
            this.close();
          }
        });
      });
      this.closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.close();
      });
      document.body.addEventListener('keydown', (event) => {
        if (event.key == "Escape") {
          event.preventDefault();
          this.close();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  open() {
    this.isOpen = true;
    this.el.classList.add("opened");
    document.querySelector("html").classList.add("modal-open");    
  }

  close() {
    this.el.classList.add("initialized");
    this.isOpen = false;
    this.el.classList.remove("opened");
    document.querySelector("html").classList.remove("modal-open");
  }
}

export default Modal;
